module.exports = __webpack_public_path__ + "img/picture7.ccd27b00.png";